import React from "react";
import MyNoteApp from "./MyNoteApp/MyNoteApp";
//import NoteApp from "./Notes_App_Egator/NoteApp";

const App = () => {
  return <MyNoteApp />;
};

export default App;
